
import { useState, useEffect } from 'react';
import { isAIServiceConnected, getAIServiceApiKey } from '@/utils/ai/aiIntegrationManager';

export interface AIServiceStatus {
  openAI: boolean;
  midjourney: boolean;
  stabilityAI: boolean;
  huggingFace: boolean;
  anyConnected: boolean;
}

export const useAIIntegration = () => {
  const [serviceStatus, setServiceStatus] = useState<AIServiceStatus>({
    openAI: false,
    midjourney: false,
    stabilityAI: false,
    huggingFace: false,
    anyConnected: false
  });

  const checkAIServices = () => {
    const openAIConnected = isAIServiceConnected('1');
    const midjourneyConnected = isAIServiceConnected('2');
    const stabilityAIConnected = isAIServiceConnected('3');
    const huggingFaceConnected = isAIServiceConnected('4');
    
    const anyConnected = openAIConnected || midjourneyConnected || stabilityAIConnected || huggingFaceConnected;
    
    setServiceStatus({
      openAI: openAIConnected,
      midjourney: midjourneyConnected,
      stabilityAI: stabilityAIConnected,
      huggingFace: huggingFaceConnected,
      anyConnected
    });
  };

  useEffect(() => {
    checkAIServices();
    
    // Listen for storage changes in case AI settings are updated in another tab
    const handleStorageChange = () => {
      checkAIServices();
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const getFirstAvailableAPIKey = (): { key: string | null, provider: string } => {
    if (serviceStatus.openAI) {
      return { key: getAIServiceApiKey('1'), provider: 'OpenAI' };
    }
    if (serviceStatus.midjourney) {
      return { key: getAIServiceApiKey('2'), provider: 'Midjourney' };
    }
    if (serviceStatus.stabilityAI) {
      return { key: getAIServiceApiKey('3'), provider: 'Stability AI' };
    }
    if (serviceStatus.huggingFace) {
      return { key: getAIServiceApiKey('4'), provider: 'Hugging Face' };
    }
    return { key: null, provider: '' };
  };

  return {
    serviceStatus,
    checkAIServices,
    getFirstAvailableAPIKey
  };
};
